import Handsontable from 'handsontable';
import { ManualColumnFreeze } from 'handsontable/plugins';
import { Selection } from 'handsontable/plugins/contextMenu';

type ActionType = Extract<keyof ManualColumnFreeze, 'freezeColumn' | 'unfreezeColumn'>;

function freeze(ht: Handsontable.Core, selection: Selection[], actionType: ActionType) {
  const colIndex = selection?.[0]?.start?.col;
  const plugin = ht.getPlugin('manualColumnFreeze');

  if (typeof colIndex !== 'number' || !plugin) {
    return;
  }

  if (!plugin.enabled) {
    plugin.enablePlugin();
  }

  plugin[actionType](colIndex);

  ht.render();
}

export function freezeColumn(this: Handsontable.Core, key: string, selection: Selection[]) {
  freeze(this, selection, 'freezeColumn');
}

export function unfreezeColumn(this: Handsontable.Core, key: string, selection: Selection[]) {
  freeze(this, selection, 'unfreezeColumn');
}

function isDisabled(ht: Handsontable.Core, actionType: ActionType) {
  try {
    const lastSelected = ht.getSelectedLast();
    const [startRowIndex, startColIndex, , endColIndex] = lastSelected ?? [];

    if (!lastSelected || startColIndex !== endColIndex) {
      return true;
    }

    const settings = ht.getSettings();
    const cellMeta = ht.getCellMeta(startRowIndex, startColIndex);

    const isFreezedCell = typeof settings.fixedColumnsLeft === 'number' && startColIndex < settings.fixedColumnsLeft;
    const isReadOnlyCell = !!cellMeta.readOnly;

    if (!isReadOnlyCell) {
      return true;
    }

    return actionType === 'freezeColumn' ? isFreezedCell : !isFreezedCell;
  } catch {
    return true;
  }
}

export function isFreezeDisabled(this: Handsontable.Core) {
  return isDisabled(this, 'freezeColumn');
}

export function isUnfreezeDisabled(this: Handsontable.Core) {
  return isDisabled(this, 'unfreezeColumn');
}
